module.exports = __webpack_public_path__ + "img/makett.345ef35.jpg";